import React from 'react';
import PropTypes from 'prop-types';

import {
  Title,
  Comment,
  ConsumerWrapper,
  OrderSummaryStyled,
  NoFee,
  Left,
  Right
} from './ConfirmationPage.style';
import OrderItem from './OrderItem';
import ConsumerDetails from './ConsumerDetails';
import FulfillmentDetails from './FulfillmentDetails';
import OrderPriceSummary from './OrderPriceSummary';
import Promotions from '../../components/Promotions/Promotions';
import noFeeIcon from '../../assets/images/noFee.png';

const OrderSummary = ({order, promotions, orderPromotions}) => {
  const orderItems = order && order.items && order.items.map((item, index) =>
    (<OrderItem
      key={`${item.mealUuid}${index}`}
      item={item}
     />));

  const orderPrice = order.price &&
    <OrderPriceSummary
      price={order.price}
      orderPromotions={orderPromotions}
    />;
  const renderNoFeeIcon = order.price && order.price.orderFee === 0 && (
    <NoFee
      src={noFeeIcon}
      alt="No card fee"
    />
  );
  const comments = order.comments && order.comments.length > 0 && <Comment>{order.comments}</Comment>;
  const consumerTitle = order.consumer && <Title>Your Details</Title>;
  const consumerDetails = order.consumer && <ConsumerDetails consumer={order.consumer} />;
  const fulfillmentDetails = order.fulfillment && order.fulfillment.delivery && <FulfillmentDetails address={order.fulfillment.address} />;
  const renderPromotions = promotions &&
    <Promotions
      promotions={promotions}
      page="confirmation"
    />;

  return (
    <OrderSummaryStyled>
      <Left>
        <Title>Order Summary</Title>
        {comments}
        {orderItems}
        {orderPrice}
        <ConsumerWrapper>
          {consumerTitle}
          {consumerDetails}
          {fulfillmentDetails}
        </ConsumerWrapper>
      </Left>
      <Right>
        {renderNoFeeIcon}
        {renderPromotions}
      </Right>
    </OrderSummaryStyled>
  );
};

OrderSummary.propTypes = {
  order: PropTypes.object.isRequired,
  promotions: PropTypes.object,
  orderPromotions: PropTypes.array
};

export default OrderSummary;



// WEBPACK FOOTER //
// ./containers/ConfirmationPage/OrderSummary.js